// extracted by mini-css-extract-plugin
export default {"control":"styles_control__FdNZJ","control__container":"styles_control__container__ZYi2q","control__nav":"styles_control__nav__J8m1u"};